import { createSlice } from '@reduxjs/toolkit'

let Slices = [];
let dataReducers = {};
let dataActions  = {};

export const gdSlice = createSlice({
    name: 'gd',
    initialState: false,
    reducers: {
        setGd: (state, action) => action.payload
    },
})
Slices.push(gdSlice);

/*---------------------------------------------------------------*/

export const userSlice = createSlice({
    name: 'userData',
    initialState: false,
    reducers: {
        setUser: (state, action) => action.payload
    },
})

// Action creators are generated for each case reducer function
Slices.push(userSlice);

/*---------------------------------------------------------------*/

export const metaTagsSlice = createSlice({
    name: 'metaTags',
    initialState: false,
    reducers: {
        setMetaTags: (state, action) => action.payload
    },
})

// Action creators are generated for each case reducer function
Slices.push(metaTagsSlice);

//build export objects
for(const Slice of Slices) {
    dataActions  = {...dataActions, ...Slice.actions};
    let reducer  = {[Slice.name]:Slice.reducer};
    dataReducers = {...dataReducers, ...reducer};
}

export { dataActions };
export { dataReducers };